export enum PRE_APPROVAL_STATUS {
  WELCOME_CALL = 'welcomeCall',
  CUSTOMER_CONDITIONS = 'customerConditions',
  CUSTOMER_CONDITIONS_SETTLEMENT = 'customerConditionsSettlement',
  TAX_INVOICE_REQUEST = 'taxInvoiceRequest',
  PRIVATE_SALE_REQUEST = 'privateSaleRequest',
  CONTRACT_GENERATION = 'contractGeneration',
  SIGNING_PENDING = 'signingPending',
  SETTLEMENT_PENDING = 'settlementPending',
  DELAYED_DELIVERY = 'delayedDelivery',
  VEHICLE_SEARCH = 'vehicleSearch',
  UNRESPONSIVE = 'unresponsive',
  NOT_PROCEEDING = 'notProceeding',
  EMPLOYER_APPROVAL_PENDING = 'employerApprovalPending',
  TAX_INVOICE_RECEIVED = 'taxInvoiceReceived',
  INSPECTION_REPORT_RECEIVED = 'inspectionReportReceived',
  SETTLEMENT_HELD = 'settlementHeld',
}

export const preApprovalStatusOptions = Object.values(PRE_APPROVAL_STATUS)

export type PreApprovalStatusType = (typeof preApprovalStatusOptions)[number]

export const preApprovalStatusMap = {
  [PRE_APPROVAL_STATUS.WELCOME_CALL]: 'Requires Pre-approval Call',
  [PRE_APPROVAL_STATUS.CUSTOMER_CONDITIONS]: 'Awaiting Settlement Conditions From Customer',
  [PRE_APPROVAL_STATUS.CUSTOMER_CONDITIONS_SETTLEMENT]: 'Customer Conditions - Settlements',
  [PRE_APPROVAL_STATUS.TAX_INVOICE_REQUEST]: 'Tax Invoice Request',
  [PRE_APPROVAL_STATUS.PRIVATE_SALE_REQUEST]: 'Verimoto Pending',
  [PRE_APPROVAL_STATUS.CONTRACT_GENERATION]: 'Lender Contract Generator',
  [PRE_APPROVAL_STATUS.SIGNING_PENDING]: 'Documents for Customer for Signing',
  [PRE_APPROVAL_STATUS.SETTLEMENT_PENDING]: 'Settlement Pending',
  [PRE_APPROVAL_STATUS.DELAYED_DELIVERY]: 'Delayed Delivery',
  [PRE_APPROVAL_STATUS.VEHICLE_SEARCH]: 'Vehicle Search',
  [PRE_APPROVAL_STATUS.UNRESPONSIVE]: 'Unresponsive',
  [PRE_APPROVAL_STATUS.NOT_PROCEEDING]: 'Not Proceeding',
  [PRE_APPROVAL_STATUS.EMPLOYER_APPROVAL_PENDING]: 'Employer Approval Pending',
  [PRE_APPROVAL_STATUS.TAX_INVOICE_RECEIVED]: 'Tax Invoice Received',
  [PRE_APPROVAL_STATUS.INSPECTION_REPORT_RECEIVED]: 'Inspection Report Received',
  [PRE_APPROVAL_STATUS.SETTLEMENT_HELD]: 'Settlement Held',
}
